__turbopack_context__.v({
  "user-department": "Department-module-scss-module__nwhkLa__user-department",
  "user-department-container": "Department-module-scss-module__nwhkLa__user-department-container",
});
